/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Link } from 'react-router';
import { find } from 'lodash';
import { CSVLink } from 'react-csv';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {  getKeys, getCSVSecondaryCreation } from '../../../../../utils/downloadReports';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

// Utils
import {
  getSorting,
  stableSort,
  getCompletionStatus,
  getNumApprovedRequirements,
  getQuestRequirements,
  getQuestRequirementsForDisplay,
  keyDistributionStepExists,
  parseLinks,
  calculateSecondaryCreationRewards
} from '../../../../../utils/functions';

// Custom Modal
import CustomLinkModal from '../CustomLinkModal';
import RejectVideoModal from '../RejectVideoModal';

// Styles
import '../QuestDetailsTable.scss';

const TableHeaderCell = withStyles(() => ({
  head: {
    color: '#9b9b9b',
    fontWeight: '400',
    fontSize: '14px',
    padding:"8px"
  },
}))(TableCell);

// 独立渲染Tab
function RenderTabs({ usersTab, approvedUsers, leftQuestUsers, setTab }) {
  const tabs = [
    { label: `In Quest (${approvedUsers.length})`, key: 0 },
    ...(leftQuestUsers.length > 0 ? [{ label: `Left Quest (${leftQuestUsers.length})`, key: 1 }] : []),
  ];
  return (
    <div className="Global__subTabs" style={{ padding: '0px 30px 10px 30px' }}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={classNames('Global__subTab', { active: usersTab === tab.key })}
          onClick={() => setTab(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
}

// 独立渲染用户需求
function RenderUserRequirements({ user, userQuest, quest, handleComplete, handleReject, openVODModals }) {
  const requirements = getQuestRequirementsForDisplay(quest, true);
  return (
    <>
      <TableRow>
        <TableCell colSpan="12">
          <Table>
            <TableHead>
              <TableRow>
                <TableHeaderCell align="left"> Mark Complete </TableHeaderCell>
                <TableHeaderCell align="left"> Requirement </TableHeaderCell>
                <TableHeaderCell align="left"> Reason </TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requirements && requirements.length > 0 &&
                requirements.map((requirement) => {
                  const { type, subtype, approvalRequired } = requirement;
                  const userQuestRequirements = (userQuest && userQuest.requirements) ? userQuest.requirements : [];
                  const userRequirement = find(userQuestRequirements, (o) => o.questReqId === requirement.id);
                  // 多视频需求
                  if (userRequirement && type === 'multi-video-submission' && Array.isArray(userRequirement?.videos)) {
                    return userRequirement.videos.map((video, idx) => {
                      const statusClass = classNames({
                        success: video.status === 'valid',
                        error: video.status === 'invalid',
                      });
                      return (
                        <TableRow key={video.videoId || idx}>
                          <TableCell>
                            <RejectVideoModal
                              videoUrl={video.url}
                              onReject={(reason) => handleReject(user, quest, requirement, video, reason)}
                            />
                          </TableCell>
                          <TableCell>
                            <span className={statusClass}>
                              Youtube Link:&nbsp;<Link href={video.url} target="_blank">{video.url}</Link>
                            </span>
                          </TableCell>
                          <TableCell>{video.note ? <span className={statusClass}><i>{video.note}</i></span> : null}</TableCell>
                        </TableRow>
                      );
                    });
                  }
                  // 其它类型
                  const statusClass = classNames({
                    success: userRequirement && userRequirement.status === 'completed',
                    error: userRequirement && userRequirement.status === 'rejected',
                    warning: !userRequirement || (userRequirement && (userRequirement.status !== 'completed' && userRequirement.status !== 'rejected')),
                  });
                  let text = '';
                  if (userRequirement) {
                    if (type === 'submit-tweet') {
                      text = <TableCell><span className={statusClass}>Twitter Link:&nbsp;{userRequirement.content}</span></TableCell>;
                    } else if (type === 'submit-link' && (subtype && subtype === 'vod')) {
                      text = (
                        <TableCell>
                          <span className={statusClass}>{'VOD Link:'}&nbsp;{userRequirement.content}</span>
                          {userRequirement.status === 'completed' ? (
                            <button className="small-btn" style={{ margin: '0 0 0 5px' }} onClick={() => openVODModals(user.id, userRequirement.questReqId)}>
                              <i className="fa fa-address-card" />
                            </button>
                          ) : null}
                        </TableCell>
                      );
                    } else if (type === 'multi-video-submission') {
                      text = <TableCell><span className={statusClass}>Youtube Link:&nbsp;{userRequirement.content}</span></TableCell>;
                    } else if (type === 'submit-link') {
                      text = <TableCell><span className={statusClass}>{subtype === 'vod' ? 'VOD Link:' : 'Clip Link:'}&nbsp;{userRequirement.content}</span></TableCell>;
                    } else if (type === 'submit-text' || type === 'submit-text-optional') {
                      text = <TableCell><span className={statusClass}>{requirement.title}: {parseLinks(userRequirement.content)}</span></TableCell>;
                    } else if (approvalRequired) {
                      text = <TableCell><span className={statusClass}>{`Checkbox submitted: ${requirement.title}`}</span></TableCell>;
                    }
                  } else if (type === 'multi-video-submission') {
                    text = <TableCell><span className="warning"><i>Youtube Link Pending</i></span></TableCell>;
                  } else if (type === 'submit-tweet') {
                    text = <TableCell><span className="warning"><i>Twitter Link Pending</i></span></TableCell>;
                  } else if (type === 'submit-link') {
                    text = <TableCell><span className="warning"><i>{subtype === 'vod' ? 'VOD Link Pending' : 'Clip Link Pending'}</i></span></TableCell>;
                  } else if (type === 'submit-text' || type === 'submit-text-optional') {
                    text = <TableCell><span className="warning"><i>Text Submission Pending</i></span></TableCell>;
                  } else if (approvalRequired) {
                    text = <TableCell><span className="warning">Checkbox pending</span></TableCell>;
                  }
                  let noteHtml = <TableCell />;
                  if (userRequirement && userRequirement.note) {
                    noteHtml = <TableCell><span className={statusClass}><i>{userRequirement.note}</i></span></TableCell>;
                  }
                  let completeButton = <TableCell />;
                  if (!userRequirement || (userRequirement && userRequirement.status !== 'completed')) {
                    completeButton = (
                      <TableCell>
                        <CustomLinkModal
                          completeSelected={(link) => handleComplete(user, quest, requirement, link)}
                          selectedCheckboxesLength={1}
                          {...(userRequirement && userRequirement.link ? { existingLink: userRequirement.link } : {})}
                        />
                      </TableCell>
                    );
                  }
                  return (
                    <TableRow key={requirement.id}>
                      {completeButton}
                      {text}
                      {noteHtml}
                    </TableRow>
                  );
                })}
              {userQuest && userQuest.promoLink && (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeaderCell colSpan="8" align="left"> Promo Link </TableHeaderCell>
                      <TableHeaderCell colSpan="8" align="left"> Clicks</TableHeaderCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan="8"><a href={`http://${userQuest.promoLink}`} target="_blank" rel="noopener noreferrer">{userQuest.promoLink}</a></TableCell>
                      <TableCell colSpan="8">{userQuest.promoLinkClicks}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </TableBody>
          </Table>
        </TableCell>
      </TableRow>
      {userQuest && userQuest.leftQuestReason && (
        <TableRow>
          <TableCell colSpan="8">
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell align="left">Reason for Leaving</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ padding: '0.67em' }}>
                  <TableCell colSpan="8">{userQuest.leftQuestReason}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

class QuestDetailsTableSecond extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderBy: 'Rank',
      order: 'asc',
      showingElements: [],
      usersTab: 0,
      showingSplitTiers: [],
    };
  }

  handleRequestSort = (event, property) => {
    const { order, orderBy } = this.state;
    const isDesc = order === 'desc' && orderBy === property;
    this.setState({
      order: isDesc ? 'asc' : 'desc',
      orderBy: property,
    });
  };

  toggleElementInfo = (elementId) => {
    this.setState((prev) => ({
      showingElements: prev.showingElements.includes(elementId)
        ? prev.showingElements.filter((id) => id !== elementId)
        : [...prev.showingElements, elementId],
    }));
  };

  toggleSplitTierInfo = (username) => {
    this.setState((prev) => ({
      showingSplitTiers: prev.showingSplitTiers.includes(username)
        ? prev.showingSplitTiers.filter((u) => u !== username)
        : [...prev.showingSplitTiers, username],
    }));
  };

  handleComplete = (user, quest, requirement, content) => {
    const { id, title, type, subtype } = requirement;
    const reqToUpdate = {
      userId: user.id,
      questId: quest.id,
      reqId: id,
      title,
      type,
      subtype,
      status: 'completed',
      override: true,
      overriddenByUser: this.props.auth.user.id,
      content: content || 'Admin Override',
    };
    const data = JSON.stringify(reqToUpdate);
    this.props.postCCRequirement(data, this.props.auth.token);
  };

  handleReject = (user, quest, requirement, video, rejectReason) => {
    const { id, title, type, subtype } = requirement;
    video.note = rejectReason;
    video.status = 'invalid';
    const reqToUpdate = {
      userId: user.id,
      questId: quest.id,
      reqId: id,
      title,
      video,
      type,
      subtype,
      status: 'completed',
      override: true,
      overriddenByUser: this.props.auth.user.id,
    };
    const data = JSON.stringify(reqToUpdate);
    this.props.postCCRequirement(data, this.props.auth.token);
  };

  handleKickUser = (userId) => {
    const { quest, auth, kickUserFromQuest } = this.props;
    if (window.confirm('确定要将该用户踢出任务吗？')) {
      kickUserFromQuest(userId, quest.id, auth.token);
    }
  };

  getTableHeaders = (questType, platform, keyDistribute) => {
    const { usersTab } = this.state;
    let tableHeaders = [
      { id: 'rank', label: 'Rank' },
      { id: 'username', label: 'Noiz' },
      { id: 'youtubeUsername', label: 'YoutubeID' },
      { id: 'totalViews', label: 'Total Views' },
      { id: 'totalLikes', label: 'Total Likes' },
      { id: 'totalComments', label: 'Total Comments' },
      { id: 'totalShares', label: 'Total Shares' },
      { id: 'avgCompletePercentage', label: 'Avg Watch Duration' },
      { id: 'overallScore', label: 'Overall Score' },
      { id: 'splitPrize', label: 'Tier Amount' },
      { id: 'rankPrize', label: 'Rank Amount' },
      { id: 'actions', label: 'Actions' },
    ];
    if (usersTab === 0 && keyDistribute) {
      tableHeaders.push({ id: 'gameKey', numeric: false, disablePadding: true, label: '' });
    }
    return tableHeaders;
  };

  setTab = (tabKey) => {
    this.setState({ usersTab: tabKey });
  };

  renderUserSplitTiers = (tierDetails) => (
    <TableRow>
      <TableCell colSpan="12">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell align="left">Tier</TableHeaderCell>
              <TableHeaderCell align="left">Split Amount</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tierDetails.map((detail, index) => (
              <TableRow key={`tier-${index + 1}`}>
                <TableCell>Tier {detail.tierIndex}</TableCell>
                <TableCell><span className="success">{detail.finalAmount}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableCell>
    </TableRow>
  );

  getUserRows = (users, questType, platform, keyDistribute) => {
    const { quest, userQuests, openCongenialityModal, openVODModals } = this.props;
    const { order, orderBy, showingElements, showingSplitTiers } = this.state;
    const sortedUsers = stableSort(
      users.map(user => ({
        ...user,
        rank: user.rank,
        username: user.user?.username,
        youtubeUsername: user.user?.connectedAccounts?.youtube?.username,
        totalViews: user.totalViews,
        totalLikes: user.totalLikes,
        totalComments: user.totalComments,
        totalShares: user.totalShares,
        avgCompletePercentage: user.avgCompletePercentage,
        overallScore: user.overallScore,
        splitPrize: user.splitPrize,
        rankPrize: user.rankPrize,
      })),
      getSorting(order, orderBy)
    );
    const numberRequirements = getQuestRequirements(quest, true).length;
    let allRewards = {};
    if (quest.splitTiers && quest.splitTiers.length > 0) {
      try {
        console.log("userQuests", userQuests)
        console.log("quest", quest)
        const userStats = sortedUsers.map(user => ({
          userId: user.id || user.user?.id,
          overallScore: user.overallScore,
          totalUploadDays: user.totalUploadDays || (user.uploadDates ? user.uploadDates.length : 0),
          validVideoCount: user.validVideoCount,
          totalViews: user.totalViews
        }));
        console.log("userStats", userStats)
        allRewards = calculateSecondaryCreationRewards(quest.splitTiers, userStats);
        console.log("allRewards", allRewards)
      } catch (e) {
        allRewards = {};
      }
    }
    return sortedUsers.map((user) => {
      console.log("user", user)
      const userQuest = find(userQuests, (o) => o.user.id === user.id);
      const sumCompletedRequirements = getNumApprovedRequirements(quest, userQuest);
      const showUserRequirements = showingElements.indexOf(user.username) !== -1;
      const showTiers = showingSplitTiers.includes(user.username);
      const username = user.user?.username || '-';
      const youtubeAccount = user.user?.connectedAccounts?.youtube;
      let tierDetails = [];
      if (quest.splitTiers && allRewards.tierDetails) {
        tierDetails = quest.splitTiers.map((tier, index) => {
          const tierId = `tier_${index}`;
          const tierDetail = allRewards.tierDetails[tierId]?.userRewards[user.id];
          return tierDetail || null;
        });
      }
      const hasTierReward = tierDetails.some(detail => detail && detail.finalAmount > 0);
      return (
        <React.Fragment key={user.id}>
          <TableRow hover tabIndex={-1} key={user.id}>
            <TableCell align="center" style={{ fontWeight: this.state.orderBy === 'Rank' ? 'bold' : 'normal' }}>{user.rank ?? '-'}</TableCell>
            <TableCell align="center">{username}</TableCell>
            <TableCell align="center">
              {youtubeAccount?.username ? (
                <a
                  href={`https://www.youtube.com/channel/${youtubeAccount.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#3a74e0', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  {youtubeAccount.username}
                </a>
              ) : '-'}
            </TableCell>
            <TableCell align="center">{user.totalViews ?? '-'}</TableCell>
            <TableCell align="center">{user.totalLikes ?? '-'}</TableCell>
            <TableCell align="center">{user.totalComments ?? '-'}</TableCell>
            <TableCell align="center">{user.totalShares ?? '-'}</TableCell>
            <TableCell align="center">{user.avgCompletePercentage ? user.avgCompletePercentage + '%' : '-'}</TableCell>
            <TableCell align="center">{user.overallScore ?? '-'}</TableCell>
            <TableCell align="center">
              {user.splitPrize}
              {hasTierReward &&
                <button
                  className={classNames('small-btn', { open: showTiers })}
                  onClick={() => this.toggleSplitTierInfo(user.username)}
                  style={{ marginLeft: '10px' }}
                >
                  {showTiers ? '-' : '+'}
                </button>
              }
            </TableCell>
            <TableCell align="center">{user.rankPrize ?? '-'}</TableCell>
            <TableCell align="center">
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>

                {sumCompletedRequirements >= numberRequirements && (
                  <Tooltip title="Edit reputation responses" placement="top">
                    <button className="small-btn" onClick={() => openCongenialityModal(user.id)}>
                      <i className="fa fa-address-card" />
                    </button>
                  </Tooltip>
                )}
                {numberRequirements > 0 && (
                  <React.Fragment>
                    {sumCompletedRequirements}/{numberRequirements}&nbsp;
                  </React.Fragment>
                )}
                <button
                  className={classNames('small-btn', { open: showUserRequirements })}
                  onClick={() => this.toggleElementInfo(user.username)}
                >
                  {showUserRequirements ? '-' : '+'}
                </button>
              </div>
            </TableCell>
          </TableRow>
          {showTiers && this.renderUserSplitTiers(tierDetails)}
          {showUserRequirements && (
            <RenderUserRequirements
              user={user}
              userQuest={userQuest}
              quest={quest}
              handleComplete={this.handleComplete}
              handleReject={this.handleReject}
              openVODModals={openVODModals}
            />
          )}
        </React.Fragment>
      );
    });
  };

  render() {
    const { questType, users, quest, userQuests } = this.props;
    console.log("users", users)
    const { usersTab } = this.state;
    const platform = quest.twitchAccountRequired ? 'twitch' : 'twitch';
    const usersWithStatus = users.map((user) => {
      const userQuest = find(userQuests, (o) => o.user.id === user.id);
      return {
        ...user,
        completionStatus: getCompletionStatus(quest, userQuest, user.timePlaying),
        chatDetails: userQuest?.chatDetails,
      };
    });
    const approvedUsers = usersWithStatus.filter((user) => user.status !== 'leftQuest');
    const failedUsers = approvedUsers.filter((user) => user.completionStatus.status === 'F');
    const leftQuestUsers = usersWithStatus.filter((user) => user.status === 'leftQuest');
    const currentTabUsers = usersTab === 0 ? approvedUsers : leftQuestUsers;
    const keyDistribute = quest.keyRequired && keyDistributionStepExists(quest);
    const secondaryCSV = getCSVSecondaryCreation(currentTabUsers, quest, userQuests);
    const keysCSV = getKeys([].concat(failedUsers, leftQuestUsers), platform, quest);
    const createSortHandler = (property) => (event) => {
      this.handleRequestSort(event, property);
    };
    return (
      <section className="ToggleTable">
        {currentTabUsers.length ? (
          <React.Fragment>
            <section className="ToggleTable__header">
              <h3 className="ToggleTable__header-title">Users: <span>{currentTabUsers?.length}</span></h3>
              {currentTabUsers?.length && (
                <div className="ToggleTable__header-buttons">
                  <Tooltip title="Report CSV" placement="top">
                    <CSVLink
                      data={secondaryCSV.dataCSV}
                      headers={secondaryCSV.headers}
                      filename={quest && quest.game ? `${quest.game.name} - ${quest.title}.csv` : 'report.csv'}
                    >
                      <i className="fa fa-download" />
                    </CSVLink>
                  </Tooltip>
                  {quest.keyRequired && (
                    <Tooltip title="Keys to Revoke" placement="top">
                      <CSVLink
                        data={keysCSV.dataCSV}
                        headers={keysCSV.headers}
                        filename={quest && quest.game ? `${quest.game.name} - ${quest.title} - KeysToRevoke.csv` : 'keysToRevoke.csv'}
                      >
                        <i className="fa fa-key" />
                      </CSVLink>
                    </Tooltip>
                  )}
                </div>
              )}
            </section>
            <RenderTabs
              usersTab={usersTab}
              approvedUsers={approvedUsers}
              leftQuestUsers={leftQuestUsers}
              setTab={this.setTab}
            />
            <div className="table-scroll-container">
              <Table>
                <TableHead>
                  <TableRow>
                    {this.getTableHeaders(questType, platform, keyDistribute).map((headCell) => (
                      <TableHeaderCell
                        key={headCell.id}
                        align="center"
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection="asc"
                      >
                        <TableSortLabel
                          active={this.state.orderBy === headCell.id}
                          direction={this.state.order}
                          onClick={createSortHandler(headCell.id)}
                          IconComponent={ArrowDropDownIcon}
                          style={{ marginLeft: '30px' }}
                        >
                          {headCell.label}
                          {this.state.orderBy === headCell.id ? (
                            <span style={{ display: 'none' }}>
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      </TableHeaderCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.getUserRows(currentTabUsers, questType, platform, keyDistribute)}
                </TableBody>
              </Table>
            </div>
          </React.Fragment>
        ) : (
          <div className="NoQuestTiered">No one has joined yet.</div>
        )}
      </section>
    );
  }
}

QuestDetailsTableSecond.propTypes = {
  questType: PropTypes.string,
  users: PropTypes.array.isRequired,
  quest: PropTypes.object.isRequired,
  userQuests: PropTypes.array.isRequired,
  postCCRequirement: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  openCongenialityModal: PropTypes.func,
  openVODModals: PropTypes.func,
  kickUserFromQuest: PropTypes.func,
};

export default QuestDetailsTableSecond;
